import React, { Component } from 'react'

import { graphql } from '@apollo/client/react/hoc'
import gql from 'graphql-tag'
import { Col, Row, Input, Popover, PopoverBody, PopoverHeader, InputGroupText, InputGroup } from 'reactstrap'
import ListingFilters from "../../Material/ListingFilters"
import { debounce } from 'lodash'
import '../../Drivers/DriversNew/DriversListContainer.css'
import renderEnumToInt from '../../Functions/renderEnumToInt'
import toTitleCase from '../../Functions/toTitleCase'
import StripeModal from "../../Stripe/StripeModal"
import NewTransaction from './NewTransaction'
import DownloadTransactions from "./DownloadTransactions"
import NewPaymentPlan from './NewPaymentPlan'
import { HasPermissionsQuery } from "../../Functions/querys"
import handleConfigurationChange from "../../Functions/handleConfigurationChange"
import getFilterValuesFromQueryString from "../../Functions/getFilterValuesFromQueryString"
import TablePreferencePicker from "../../Material/TablePreferencePicker"
import PaymentScheduleModal from "../PaymentSchedules/PaymentScheduleModal"
import { DateRange } from "react-date-range"
import moment from "moment"
import Select from "react-select"

import withApolloClient from '../../withApolloClient'



const AllChargeTypes = gql`query AllChargeTypes{
    optionsList: allChargeTypes(isActive:true,orderBy:["name"]){
        edges {
          node {
            id
            name
            category
          }
        }
      }
}`

const AllGroupTypes = gql`query AllGroupTypes{
    optionsList: allGroupTypes(isActive:true,orderBy:["name"]){
      edges {
        node {
          id
          name
        }
      }
    }
}`

const dateFilterTypes = ["Event Datetime", "Date Added"]

class TransactionListFilters extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            configurations: null,
            loading: false,
            transactionsSum: null,
            filtersLoading: true,
        }
        this.getFilters = this.getFilters.bind(this)
    }
    getFilterConfigurations = () => {
        return [
            { type: "number", name: "minAmount", title: "Min Amount", placeholder: "0", showFilter: true },
            { type: "number", name: "maxAmount", title: "Max Amount", placeholder: "10000", showFilter: true },
            {
                type: "select", name: "chargeTypeIds", title: "Charge Types", optionsQuery: AllChargeTypes, labelSelector: "name", valueSelector: "id", placeholder: "Filter By Charge Types", showFilter: true, isMulti: true,
            },
            {
                type: "select", name: "groupTypeIds", title: "Sub-Charge Types", optionsQuery: AllGroupTypes, labelSelector: "name", valueSelector: "id", placeholder: "Filter by Sub-Charge Type", showFilter: true, isMulti: true,
            },
            {
                type: "boolean", name: "includeUpdates", title: "Show Updates", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Include Updates", showFilter: true
            },
            {
                type: "select", name: "ignoreUpdatesExceptChargeIds", title: "Ignore Updates Except", optionsQuery: AllChargeTypes, labelSelector: "name", valueSelector: "id", placeholder: "Exclude By Charge Types", showFilter: true, isMulti: true,
            },
            {
                type: "boolean", name: "includeDeleted", title: "Include Deleted", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Include Deleted", showFilter: true
            },
            {
                type: "boolean", name: "paymentPlanCompatible", title: "Plan Compatible", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Payment Plan Compatible", showFilter: true
            },
        ]
    }

    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }
    updateNotes = debounce((notes) => {
        this.updateFilters({ ...this.props.filterValues, notes })
    }, 500)
    removeFilter = (filterName) => {
        let filterValues = this.props.filterValues
        let filterKeys = Object.keys(filterValues)
        if (filterKeys.includes(filterName)) {
            delete filterValues[filterName]
            this.updateFilters({ ...filterValues })
        }
    }
    getValueByFilterType = (filterConfigs, value) => {
        if (filterConfigs.type === "select") {
            let options = filterConfigs["options"]
            if (options && options.length > 0) {
                if (Array.isArray(value)) {
                    value = value.map(item => options.find(option => option.value === item)?.label)
                } else {
                    if (value === true) {
                        value = 'true'
                    }
                    else if (value === false) {
                        value = 'false'
                    }
                    value = options.find(option => option.value === value) && options.find(option => option.value === value).label
                }
            }
        } else if (filterConfigs.type === "boolean")
            value = toTitleCase(value.toString())
        return Array.isArray(value) ? value.join(", ") : value
    }
    async getFilters() {
        let conf = this.getFilterConfigurations()
        let configurations = conf.filter(filter => filter['showFilter'])
        const updatedConfs = await Promise.all(
            configurations.map(async filter => {
                if (filter['optionsQuery']) {
                    let options = []
                    const { data } = await this.props.apolloClient.query({
                        query: filter.optionsQuery,
                        variables: { ...filter.variables }
                    })
                    if (data && data.optionsList && data.optionsList.edges && data.optionsList.edges.length > 0)
                        options = data.optionsList.edges.map(options => options.node && ({ value: options.node[filter.valueSelector], label: options.node[filter.labelSelector] }))
                    else if (data && data.optionsList && data.optionsList.states && data.optionsList.states.length > 0) {
                        options = data.optionsList.states.map(options => options.node ? ({ value: options.node[filter.valueSelector], label: options.node[filter.labelSelector] }) : ({ value: filter.extractValue ? renderEnumToInt(options[filter.valueSelector]) : options[filter.valueSelector], label: options[filter.labelSelector] }))
                    }
                    filter['options'] = options
                    delete filter['optionsQuery']
                }
                return filter
            })
        )
        this.setState({ configurations: updatedConfs, filtersLoading: false })
    }
    componentDidMount() {
        if (this.props.activeTab)
            this.getFilters()
        const { apolloClient } = this.props
    }

    updateFilters = (filters, conf = this.state.configurations, navigate = this.props.navigate, location = this.props.location, setFilterValues = this.props.setFilterValues) => {
        let visibleFilters = conf.filter(item => item.showFilter).map(item => item.name)
        let newFilterValues = { tab: "transactions" }
        Object.keys(filters).map(key => {
            if (visibleFilters.includes(key) || key === "searchTerm")
                newFilterValues[key] = filters[key]
        })
        const queryString = new URLSearchParams(newFilterValues).toString()

        navigate({ hash: location.hash, search: queryString })
        this.props.resetSelectedTransactions()
        setFilterValues({ ...filters })
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.activeTab !== prevProps.activeTab) {
            this.getFilters(this.props.activeTab)
        }

        let hasIncludeUpdates = this.state.configurations && this.state.configurations.find(setting => setting.name === "includeUpdates")
        if (((this.props.filterValues.chargeTypeIds && this.props.filterValues.chargeTypeIds.length > 0) || (this.props.filterValues.groupTypeIds && this.props.filterValues.groupTypeIds.length > 0)) && !hasIncludeUpdates) {
            let filters = this.getFilterConfigurations()
            filters.find(filter => filter.name === "includeUpdates").showFilter = true
            this.setState({ configurations: [...filters] })
        }

        let ignoreUpdatesExceptChargeIds = this.state.configurations && this.state.configurations.find(setting => setting.name === "ignoreUpdatesExceptChargeIds")
        if (this.props.filterValues !== prevProps.filterValues) {
            if (this.props.filterValues.includeUpdates !== null && this.props.filterValues.includeUpdates === false && ignoreUpdatesExceptChargeIds.showFilter === false) {
                let filters = this.state.configurations
                filters.find(filter => filter.name === "ignoreUpdatesExceptChargeIds").showFilter = true
                this.setState({ configurations: [...filters] })
            } else if ((this.props.filterValues.includeUpdates === undefined || this.props.filterValues.includeUpdates === true) && ignoreUpdatesExceptChargeIds.showFilter === true) {
                let filters = this.state.configurations
                let filterValues = this.props.filterValues
                delete filterValues['ignoreUpdatesExceptChargeIds']
                filters.find(filter => filter.name === "ignoreUpdatesExceptChargeIds").showFilter = false
                this.props.setFilterValues({ ...filterValues })
                this.setState({ configurations: [...filters] })
            }
        }

        if (this.state.configurations !== prevState.configurations && window.location.hash === "#billing") {
            let urlFilterValues = getFilterValuesFromQueryString(this.props.location.search, this.state.configurations)
            handleConfigurationChange(prevState.configurations, this.state.configurations, urlFilterValues, this.props.setFilterValues, this.props.navigate, this.props.location, this.props.defaultFilters, this.updateFilters)
        }
    }

    applyDateFitler = () => {
        this.setState({ showDateRangePopup: true })
        let startDate = this.props.filterValues && this.props.filterValues.selectionRange && this.props.filterValues.selectionRange[0].startDate ? this.props.filterValues.selectionRange[0].startDate : new Date()
        let endDate = this.props.filterValues && this.props.filterValues.selectionRange && this.props.filterValues.selectionRange[0].endDate ? this.props.filterValues.selectionRange[0].endDate : null
        this.props.setFilterValues({ ...this.props.filterValues, selectionRange: [{ startDate, endDate, key: 'selection' }] })
    }
    clearDateFilter = () => {
        let filterValues = this.props.filterValues
        filterValues = delete filterValues['selectionRange']
        this.props.setFilterValues({ ...this.props.filterValues })
    }
    updateDateFilterType = (dateFilterType) => {
        let { filterValues } = this.props
        this.props.setFilterValues({ ...filterValues })
        this.props.updateDateFilterType(dateFilterType)
    }
    render() {
        return (
            <Row className="mt-2">
                {this.state.openModal === "viewFilters" &&
                    <ListingFilters open={this.state.openModal === "viewFilters"} handleClose={() => this.toggleModal("")}
                        target="viewFilters" filterValues={this.props.filterValues} setFilterValues={(filters => this.updateFilters(filters))}
                        filters={this.state.configurations}
                    />
                }
                {this.state.openModal === "NewTransaction" &&
                    <NewTransaction handleClose={() => this.toggleModal("")} open={this.state.openModal === "NewTransaction"}
                        refetchQuery={this.props.refetchQuery} driverId={this.props.driverId}
                    />
                }
                {this.state.openModal === "NewPaymentSchedule" &&
                    <PaymentScheduleModal handleClose={() => this.toggleModal("")} open={this.state.openModal === "NewPaymentSchedule"} refetchQuery={this.props.refetchDriver} driverId={this.props.driverId} action="CREATE" />
                }
                {this.state.openModal === "NewPaymentPlan" &&
                    <NewPaymentPlan handleClose={() => this.toggleModal("")} open={this.state.openModal === "NewPaymentPlan"} selectedTransactions={this.props.selectedTransactions} refetchQuery={this.props.refetchQuery} refetchDriver={this.props.refetchDriver} driverId={this.props.driverId} />
                }
                {this.state.openModal === "StripeModal" &&
                    <StripeModal driverId={this.props.driverId} handleClose={() => this.toggleModal("")} isOpen={this.state.openModal === "StripeModal"} refetchQuery={this.props.refetchQuery} />
                }
                {
                    this.state.openModal === "TransactionReportDownload" &&
                    <DownloadTransactions driverId={this.props.driverId} handleClose={() => this.toggleModal("")} isOpen={this.state.openModal === "TransactionReportDownload"} />
                }
                {
                    this.state.openModal === "viewColumnPicker" &&
                    <TablePreferencePicker columnConfig={this.props.columnConfig} currentUser={this.props.currentUser} open={this.state.openModal === "viewColumnPicker"} target="toggleColumnPickerButton" refetchPreferences={this.props.refetchPreferences} preferenceType={this.props.preferenceType} setColumns={this.props.setColumns} />
                }
                <Col xs={3}>
                    <span className="driver-search-filter">
                        <Input type="text" name="notes" placeholder="Search By Notes" onChange={(e) => this.updateNotes(e.target.value)} />
                        <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                    </span>
                </Col>
                <Col xs={2}>

                    <InputGroup className="mb-0 date-range-group">
                        <a id="customDateSelection" onClick={this.applyDateFitler}><InputGroupText className="h-100"><i className="fa fa-calendar" aria-hidden="true"></i></InputGroupText></a>
                        <Input disabled placeholder="Select Custom Date Range" value={this.props.filterValues && this.props.filterValues.selectionRange && this.props.filterValues.selectionRange[0].startDate && this.props.filterValues.selectionRange[0].endDate ? moment(this.props.filterValues.selectionRange[0].startDate).tz("America/New_York").format("ddd, MMM D YYYY") + " - " + moment(this.props.filterValues.selectionRange[0].endDate).tz("America/New_York").format("ddd, MMM D YYYY") : ""} />
                        {this.props.filterValues && this.props.filterValues.selectionRange && this.props.filterValues.selectionRange[0].startDate && this.props.filterValues.selectionRange[0].endDate && <i className="fa fa-times-circle-o reset-date-range" onClick={() => this.clearDateFilter()} aria-hidden="true"></i>}
                        <Popover trigger="legacy" placement="bottom" isOpen={this.state.showDateRangePopup} target="customDateSelection" toggle={() => this.setState({ showDateRangePopup: false })}>
                            <PopoverHeader className="text-center">Select Date Range</PopoverHeader>
                            <PopoverBody>
                                <>
                                    <Select
                                        key="dateFilterType"
                                        className="bos-custom-select"
                                        classNamePrefix="bos-select"
                                        placeholder="Filter By Date"
                                        options={dateFilterTypes.map(item => ({ value: item, label: "Filter By " + item }))}
                                        defaultValue={dateFilterTypes.filter(value => value === this.props.dateFilterType).map(item => ({ value: item, label: "Filter By " + item }))}
                                        onChange={item => this.updateDateFilterType(item.value)}
                                    />
                                    <br />
                                </>
                                <DateRange key="dateRange" ranges={this.props.filterValues && this.props.filterValues.selectionRange}
                                    onChange={(ranges) => {
                                        this.props.resetSelectedTransactions()
                                        this.props.setFilterValues({ ...this.props.filterValues, selectionRange: [ranges.selection] })
                                    }}
                                    editableDateInputs={true} moveRangeOnFirstSelection={true}
                                />
                            </PopoverBody>
                        </Popover>
                    </InputGroup>
                </Col>
                <Col xs={7} className="text-right pt-2">
                    <Popover trigger="legacy" placement="bottom" className="transaction-action-items" target="viewActions" isOpen={this.state.openModal === "viewActions"} toggle={() => this.toggleModal("")}>
                        <PopoverBody>
                            <ul>
                                {this.props.hasPermissions && this.props.hasPermissions.includes("add_paymentplan") && this.props.selectedTransactions && this.props.selectedTransactions.length > 0 && <li><a id="NewPaymentPlan" className="driver-list-button" onClick={() => this.toggleModal("NewPaymentPlan")}>
                                    <i className="fa fa-credit-card" aria-hidden="true"></i> | NEW PAYMENT PLAN
                                </a></li>}
                                {this.props.hasPermissions && this.props.hasPermissions.includes("add_paymentschedule") &&
                                    <li>
                                        <a id="NewPaymentSchedule" className="driver-list-button" onClick={() => this.toggleModal("NewPaymentSchedule")}>
                                            <i className="fa fa-clock-o" aria-hidden="true"></i> | SCHEDULE PAYMENT
                                        </a>
                                    </li>
                                }
                                <li>
                                    <a id="TransactionReportDownload" className="driver-list-button" onClick={() => this.toggleModal("TransactionReportDownload")}>
                                        <i className="fa fa-download" aria-hidden="true"></i> | DOWNLOAD HISTORY
                                    </a>
                                </li>
                                <li>
                                    <a id="StripeModal" className="driver-list-button" onClick={() => this.toggleModal("StripeModal")}>
                                        <i className="fa fa-cc-stripe" aria-hidden="true"></i> | STRIPE
                                    </a>

                                </li>
                                <li>
                                    <a id="NewTransaction" className="driver-list-button" onClick={() => this.toggleModal("NewTransaction")}>
                                        <i className="fa fa-plus" aria-hidden="true"></i> | NEW TRANSACTION
                                    </a>
                                </li>
                            </ul>
                        </PopoverBody>
                    </Popover>
                    <a id="viewActions" className="driver-list-button" onClick={() => this.toggleModal("viewActions")}>
                        ACTIONS | <i className="fa fa-cog" aria-hidden="true"></i>
                    </a>&nbsp;&nbsp;&nbsp;&nbsp;
                    <a id="toggleColumnPickerButton" className="driver-list-button" onClick={() => this.toggleModal("viewColumnPicker")}>
                        PREFERENCE | <i className="fa fa-table" aria-hidden="true"></i>
                    </a>&nbsp;&nbsp;&nbsp;&nbsp;
                    <a id="viewFilters" className="driver-list-button" onClick={() => this.toggleModal("viewFilters")}>
                        APPLY FILTERS | <i className="fa fa-filter" aria-hidden="true"></i> {this.props.filterValues && Object.keys(this.props.filterValues).filter(key => this.props.filterValues[key] !== null && this.state.configurations && this.state.configurations.find(setting => setting.name === key) && this.state.configurations.find(setting => setting.name === key).showFilter).length || ""}
                    </a>
                </Col>
                <Col xs={12} className="mt-2">
                    {this.state.filtersLoading !== null && this.state.filtersLoading === false && Object.keys(this.props.filterValues).filter(key => this.props.filterValues[key] !== null && this.state.configurations && this.state.configurations.find(setting => setting.name === key) && this.state.configurations.find(setting => setting.name === key).showFilter).map(key =>
                        <span className="search-filter-preview">
                            <span>
                                <i className="fa fa-times-circle" onClick={() => this.removeFilter(this.state.configurations.find(setting => setting.name === key).name)}></i>&nbsp;&nbsp;
                                {this.state.configurations.find(setting => setting.name === key).title}
                            </span>
                            {this.getValueByFilterType(this.state.configurations.find(setting => setting.name === key), this.props.filterValues[key])}
                        </span>
                    )}
                    {this.props.selectedTransactions && this.props.selectedTransactions.length > 0 && <span className="search-filter-preview">
                        <span> <i className="fa fa-times-circle" onClick={this.props.resetSelectedTransactions}></i> &nbsp;&nbsp; Selected Transactions</span>
                        {this.props.selectedTransactions.length}
                    </span>}
                    {this.props.aggregatedInfo && Object.keys(this.props.aggregatedInfo).length > 0 && this.props.selectedTransactions && this.props.selectedTransactions.length > 0 && <span className="search-filter-preview aggregate-info-preview">
                        {Object.keys(this.props.aggregatedInfo).map(key =>
                            <>
                                <span>{key}</span> ${this.props.aggregatedInfo[key]}
                            </>
                        )}
                    </span>}
                </Col>
            </Row >
        )
    }
}


export default graphql(HasPermissionsQuery, {
    options: () => ({
        variables: {
            userPermissions: ['add_paymentschedule', 'add_paymentplan'],
        },
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
    }),
    props: ({ data: { hasPermissions, loading, variables } }) => ({
        hasPermissions,
        loading,
        variables,
    }),
})(withApolloClient(TransactionListFilters))